<div class="row">
  <div class="col" *ngIf="enableExport">
    <button class="btn btn-primary" (click)="onAutoExport()"
            data-toggle="modal"
            data-target="#modalLoadingExport">
      Auto Export
    </button>
  </div>
</div>
<div class="modal fade fx-modal" id="modalLoadingExport">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-shadow" style="width: 400px">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body text-white">
        <span class="button close invisible" data-dismiss="modal" aria-label="Close"></span>
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated"
               role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
               [ngStyle]="{'width': autoExport.progress + '%'}">{{autoExport.progress | number: '1.0-0'}}%</div>
        </div>
      </div>
    </div>
  </div>
</div>
